function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import Select, { components } from "react-select";
import BsArrowDown from "@meronex/icons/bs/BsArrowDown";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Option = function Option(props) {
  // console.log(props)
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(components.Option, _objectSpread(_objectSpread({}, props), {}, {
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        checked: props.isSelected,
        onChange: function onChange() {
          return null;
        }
      }), " ", /*#__PURE__*/_jsx("label", {
        children: props.label
      })]
    }))
  });
};
var MultiValueRemove = function MultiValueRemove(props) {
  return null;
};
var MultiValueLabel = function MultiValueLabel(props) {
  var _props$selectProps, _props$selectProps2;
  console.log(props);
  return /*#__PURE__*/_jsx(components.MultiValueLabel, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      children: [props.children, ((_props$selectProps = props.selectProps) === null || _props$selectProps === void 0 || (_props$selectProps = _props$selectProps.value[((_props$selectProps2 = props.selectProps) === null || _props$selectProps2 === void 0 ? void 0 : _props$selectProps2.value.length) - 1]) === null || _props$selectProps === void 0 ? void 0 : _props$selectProps.label) == props.children ? "" : ","]
    })
  }));
};
var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_jsx(components.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(BsArrowDown, {})
  }));
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  return /*#__PURE__*/_jsx(components.DropdownIndicator, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(BsArrowDown, {})
  }));
};
function CustomSelect(_ref) {
  var onChangeCallback = _ref.onChangeCallback,
    placeholder = _ref.placeholder,
    className = _ref.className,
    options = _ref.options,
    selectedValues = _ref.selectedValues,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsx(Select, {
      closeMenuOnSelect: false,
      isMulti: true,
      components: {
        Option: Option,
        MultiValueRemove: MultiValueRemove,
        MultiValueLabel: MultiValueLabel,
        IndicatorSeparator: function IndicatorSeparator() {
          return null;
        },
        DropdownIndicator: DropdownIndicator
      },
      selectionType: "text",
      options: options,
      hideSelectedOptions: false,
      backspaceRemovesValue: false,
      onChange: function onChange(e) {
        return onChangeCallback(e);
      },
      placeholder: placeholder,
      isClearable: false,
      theme: config !== null && config !== void 0 && config.darkMode ? function (theme) {
        return _objectSpread(_objectSpread({}, theme), {}, {
          colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
            neutral50: "#ccc",
            neutral80: "white",
            primary25: "#ccc",
            primary: "black",
            primary50: "white"
          })
        });
      } : undefined,
      styles: _objectSpread(_objectSpread({}, (config === null || config === void 0 ? void 0 : config.darkMode) && {
        singleValue: function singleValue(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            color: "white"
          });
        },
        menuList: function menuList(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            backgroundColor: "black",
            color: "white"
          });
        },
        option: function option(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            color: "white"
          });
        }
      }), {}, {
        multiValueLabel: function multiValueLabel(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            backgroundColor: config !== null && config !== void 0 && config.darkMode ? "black" : "#ffffff",
            color: config !== null && config !== void 0 && config.darkMode ? "#ffffff" : "black"
          });
        },
        placeholder: function placeholder(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            fontWeight: 500,
            color: config !== null && config !== void 0 && config.darkMode ? "white" : "black"
          });
        },
        valueContainer: function valueContainer(base) {
          return _objectSpread(_objectSpread(_objectSpread({}, base), (config === null || config === void 0 ? void 0 : config.darkMode) && {
            color: "white"
          }), {}, {
            padding: "11px 8px"
          });
        },
        control: function control(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            borderColor: "#DDDDDD",
            borderRadius: "0.5rem"
          }, (config === null || config === void 0 ? void 0 : config.darkMode) && {
            background: "#121212"
          });
        }
      }),
      value: selectedValues
      // {...otherProps}
    })
  });
}
export default CustomSelect;